// extracted by mini-css-extract-plugin
export default {"root":"AccountGrid_root__uAfaT"};